var termsBody = document.getElementById('terms-body');
if (termsBody) {
    $.getJSON(termsBody.getAttribute('data-terms'))
        .done(function (terms) {
            termsBody.innerHTML = terms.html;
        })
        .fail(function () {
            termsBody.textContent = 'The terms could not be loaded. Please refresh the page.';
        });
}
